<script setup lang="ts">
import { TopCategoriesProps } from "./TopCategories.props"

defineProps<TopCategoriesProps>()
</script>

<template>
  <section class="banner-top_categories padded bg-grey-main py-6 md:py-10">
    <p class="dolphin-bold md:elephant-bold mb-6">{{ title }}</p>

    <div class="md:grid-container">
      <div
        v-for="(category, index) in categories"
        :key="`category${index}`"
        class="mb-4 md:col-span-3"
      >
        <!-- Background Image and Category Title -->
        <div
          class="
            relative
            mb-4
            flex
            min-h-[54px]
            items-center
            justify-center
            md:min-h-[86px]
          "
        >
          <UtilsWrapperImage
            v-if="category.bgImage"
            v-bind="category.bgImage"
            :key="category.bgImage.image.url"
            sizes="60uti0px md:650px lg:650px xl:700px"
            class="
              wrapper-image-full-container-centered
              absolute
              inset-0
              z-0
              overflow-hidden
              rounded-lg
            "
          />
          <UtilsButton
            class="[&>span]:pig-bold z-[1] w-full text-center"
            :path="category.title.path"
            :text="category.title.label"
            :useTagHeading="false"
            theme="link-white"
          />
        </div>

        <div class="inline-flex w-full flex-col gap-4">
          <UtilsButton
            v-for="categoryItem in category.list"
            class="
              custom-btn-no-padding custom-btn-start
              [&>span]:whitespace-normal
            "
            :path="categoryItem.path"
            :text="categoryItem.label"
            theme="link-black"
          />
        </div>
      </div>
    </div>
  </section>
</template>
